module.exports = __webpack_public_path__ + "img/weibaoReport4.5063a2b3.png";